import axios from "axios";
import {toast} from "../class/Notification";

// منقضی شده
export const isActiveTiming = (open, end) => {
    let _end = new Date(end)

    return Date.now() <= _end
}

// شروع شده
export const isTimingStarted = (start, end) => {
    let _start = new Date(start)
    let _end = new Date(end)

    return Date.now() >= _start
}

// چقدر مانده
export const getTimeRemained = (open, close) => {
    var dateNow = new Date();
    let _close = new Date(close)
    let _open = new Date(open)
    dateNow = _open < dateNow ? dateNow : _open

    var seconds = Math.floor((_close - (dateNow)) / 1000);
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);

    hours = hours - (days * 24);
    minutes = minutes - (days * 24 * 60) - (hours * 60);
    seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);

    if (!isActiveTiming(open, close)) {
        return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        }
    }

    return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
    }

}


export const getNowString = () => {
    let date = new Date();
    return date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2, "0") +
        "-" + date.getDate().toString().padStart(2, "0") + " " + date.getHours().toString().padStart(2, "0") + ":" +
        date.getMinutes().toString().padStart(2, "0") + ":" + date.getSeconds().toString().padStart(2, "0");
}

const dateFormater = (date) => {
    date = new Date(date);
    return date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2, "0") +
        "-" + date.getDate().toString().padStart(2, "0") + " " + date.getHours().toString().padStart(2, "0") + ":" +
        date.getMinutes().toString().padStart(2, "0") + ":" + date.getSeconds().toString().padStart(2, "0");
}


export const isProductActive = (product) => {
    if (product.id != undefined) {

        let timers = []
        timers.push(product.timable)

        product.category.forEach((category) => {
            timers.push(category.timable)
        })

        if (product.brand != null) {
            timers.push(product.brand.timable)
        }

        let checker = true;
        timers.forEach(item => {
            if (item.status === false && item.current_active_timable.length > 0) {
                checker = false
            }
        })
        return checker;
    }
    return false
}


/*
شروع شده
منقضی شده
چقدر مانده
* */


export let TimingStatus = Object({
    ACTIVE: {value: 1, label: "فعال"},
    ENDED: {value: 0, label: "پایان یافته"},
});

export let TimingFilters = Object({
    PRODUCT: {value: "product", label: "محصول"},
    BRAND: {value: "brand", label: "برند"},
    CATEGORY: {value: "category", label: "دسته بندی"}
});


export default {
    namespaced: true,
    state: {
        timings: [],
        meta: []
    },
    mutations: {
        setTiming(state, timing) {
            state.timings = timing
        },
        setMeta(state, meta) {
            state.meta = meta
        }
    },
    actions: {
        getTimings({commit}, {page = 1, form}) {

            axios
                .post(`/timing-system/timings?page=${page}`, form)
                .then((res) => {
                    const timing = res.data.data;
                    commit("setTiming", timing.data);
                    commit("setMeta", timing.meta)
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        crateTiming({commit}, form) {

            axios
                .post(`/timing-system`, form)
                .then((res) => {
                    toast('', 'زمانبندی جدید با موفقیت ایجاد شد', 'success')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        removeTiming({commit}, form) {

            axios
                .delete(`/timing-system/${form.id}`,)
                .then((res) => {
                    toast('', 'زمانبندی حذف شد', 'success')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateTiming({commit}, form) {

            axios
                .put(`/timing-system/${form.id}`, form)
                .then((res) => {
                    toast('', 'زمانبندی با موفقیت تغییر کرد')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        crateMultipleTiming({commit}, form) {

            axios
                .post(`timing-system/create-multiple`, form)
                .then((res) => {
                    toast('', 'زمانبندی جدید با موفقیت ایجاد شد', 'success')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        checkTiming({commit}, form) {
            return axios.post(`timing/check-item/activity`, form)
        },
    },
    getters: {
        getTimings: (state) => state.timings,
        getMeta: (state) => state.meta
    },
}
